export const LINKS = {
  signup: `/acct/signup?redirectAfterSignup=${encodeURIComponent('/')}`,
  signin: `/acct/signin?redirectAfterLogin=${encodeURIComponent('/')}`,
  allAuctions: '/all-auctions',
  howItWorks: '/how-it-works/',
  howToRegister: '/blog/getting-started-how-to-register/',
  resaleCertificates: '/blog/buying-basics-resale-certificates/',
  browsingTips: '/blog/buying-basics-online-bidding-for-beginners/',
  inventoryTypes: '/blog/getting-started-inventory-types-conditions/',
  paymentMethods: '/blog/getting-started-buying-formats-and-payments/',
  shippingMethods: '/blog/buying-basics-auction-lot-shipping-methods/',
  receivingInventory:
    '/buyer-resource-a-resellers-checklist-for-receiving-inventory/',
  whyBstock: '/blog/buying-basics-who-is-b-stock-and-what-do-we-do/',
  jimRoweStory:
    '/blog/how-jim-rowe-filled-a-shopping-desert-with-costco-returns/',
  buyerResourceCenter: '/buyer-resource-center/',
} as const

export const SOLD_BY = [
  'Walmart',
  'Amazon',
  'Costco',
  'The Home Depot',
  'Target',
  'Samsung',
  'Petco',
  'Wayfair',
  'GameStop',
  'JCPenney',
] as const

export type SellerTile = {
  slug: string
  name: string
  logo: string
  listings: number
}

export const SELLERS: readonly SellerTile[] = [
  {
    slug: 'walmart',
    name: 'Walmart',
    logo: '/home-portal/images/loggedOutHomepage/seller-logo-walmart.png',
    listings: 184,
  },
  {
    slug: 'costco',
    name: 'Costco Wholesale',
    logo: '/home-portal/images/loggedOutHomepage/seller-logo-costco.png',
    listings: 62,
  },
  {
    slug: 'homedepot',
    name: 'The Home Depot',
    logo: '/home-portal/images/loggedOutHomepage/seller-logo-homedepot.png',
    listings: 97,
  },
  {
    slug: 'target',
    name: 'Target',
    logo: '/home-portal/images/loggedOutHomepage/seller-logo-target.png',
    listings: 88,
  },
  {
    slug: 'samsung',
    name: 'Samsung',
    logo: '/home-portal/images/loggedOutHomepage/seller-logo-samsung.png',
    listings: 41,
  },
  {
    slug: 'petco',
    name: 'Petco',
    logo: '/home-portal/images/loggedOutHomepage/seller-logo-petco.png',
    listings: 29,
  },
  {
    slug: 'wayfair',
    name: 'Wayfair',
    logo: '/home-portal/images/loggedOutHomepage/seller-logo-wayfair.png',
    listings: 73,
  },
  {
    slug: 'gamestop',
    name: 'GameStop',
    logo: '/home-portal/images/loggedOutHomepage/seller-logo-gamestop.png',
    listings: 18,
  },
  {
    slug: 'amazon',
    name: 'Amazon',
    logo: '/home-portal/images/loggedOutHomepage/seller-logo-amazon.png',
    listings: 156,
  },
  {
    slug: 'bjs',
    name: "BJ's",
    logo: '/home-portal/images/loggedOutHomepage/seller-logo-bjs.png',
    listings: 34,
  },
]

export type CategoryTile = {
  key:
    | 'apparel'
    | 'electronics'
    | 'homeGarden'
    | 'toys'
    | 'appliances'
    | 'healthBeauty'
    | 'furniture'
    | 'auto'
    | 'groceries'
    | 'sports'
  /** Category values as the search index spells them, not as the tile labels them. */
  searchCategories: string[]
  photo: string
  listings: number
}

export const CATEGORIES: readonly CategoryTile[] = [
  {
    key: 'apparel',
    searchCategories: ['Apparel Shoes & Accessories'],
    photo: '/home-portal/images/loggedOutHomepage/category-apparel.webp',
    listings: 412,
  },
  {
    key: 'electronics',
    searchCategories: ['Electronics'],
    photo: '/home-portal/images/loggedOutHomepage/category-electronics.webp',
    listings: 268,
  },
  {
    key: 'homeGarden',
    searchCategories: ['Home & Garden'],
    photo: '/home-portal/images/loggedOutHomepage/category-homeGarden.webp',
    listings: 331,
  },
  {
    key: 'toys',
    searchCategories: ['Toys Kids & Baby'],
    photo: '/home-portal/images/loggedOutHomepage/category-toys.webp',
    listings: 184,
  },
  {
    key: 'appliances',
    searchCategories: ['Major Appliances', 'Small Appliances'],
    photo: '/home-portal/images/loggedOutHomepage/category-appliances.webp',
    listings: 147,
  },
  {
    key: 'healthBeauty',
    searchCategories: ['Health & Beauty'],
    photo: '/home-portal/images/loggedOutHomepage/category-healthBeauty.webp',
    listings: 126,
  },
  {
    key: 'furniture',
    searchCategories: ['Furniture'],
    photo: '/home-portal/images/loggedOutHomepage/category-furniture.webp',
    listings: 98,
  },
  {
    key: 'auto',
    searchCategories: ['Automotive Supplies'],
    photo: '/home-portal/images/loggedOutHomepage/category-auto.webp',
    listings: 76,
  },
  {
    key: 'groceries',
    searchCategories: ['Groceries'],
    photo: '/home-portal/images/loggedOutHomepage/category-groceries.webp',
    listings: 64,
  },
  {
    key: 'sports',
    searchCategories: ['Sports & Outdoors'],
    photo: '/home-portal/images/loggedOutHomepage/category-sports.webp',
    listings: 58,
  },
]

export const categoryListingsUrl = (searchCategories: string[]) =>
  `${LINKS.allAuctions}?categories=${encodeURIComponent(
    JSON.stringify(searchCategories)
  )}`
